import { RenderStateViewProps } from "./RenderStateView.types";

const isEmpty = (data: unknown) => {
  return !data || (Array.isArray(data) && data.length === 0);
};

export const usePresenter = <T = unknown, P = any>(props: RenderStateViewProps<T, P>) => {
  const { data, isLoading, errorData } = props;

  const showError = Boolean(errorData);
  const showLoading = !errorData && Boolean(isLoading);
  const showEmpty = !errorData && !isLoading && isEmpty(data);
  const showFilled = !errorData && !isLoading && !isEmpty(data);

  return { showError, showLoading, showEmpty, showFilled };
};
